import IconGitHub from './components/icons/github';
import IconLinkedin from './components/icons/linkedin';
import IconTwitter from './components/icons/twitter';

const socials = [
  {
    name: 'github',
    url: 'https://github.com/kosher9',
    icon: IconGitHub,
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/in/lionel-cedric-kossi/',
    icon: IconLinkedin,
  },
  {
    name: 'twitter',
    url: 'https://twitter.com/kosherus',
    icon: IconTwitter,
  },
];

export default socials;
